import PrimaryFiltersViewModel from "./PrimaryFiltersViewModel";
import SecondaryFiltersViewModel from "./SecondaryFilteringViewModel";
import LandUsePageViewModel from "./TripRateFilterViewModel";

export default class TripRateCalculationFiltersViewModel {
    tripRateMain: string = "";
    tripRateSub: string = "";
    fetchAction?: string = undefined;
    primaryFilters?: PrimaryFiltersViewModel = new PrimaryFiltersViewModel();
    secondaryFilters?: SecondaryFiltersViewModel | null = new SecondaryFiltersViewModel();
    landUsePage: LandUsePageViewModel = new LandUsePageViewModel();
}